import { useEffect, useState, useRef } from 'react';
import logotype from '../../../assets/images/logo_mini.webp';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import './header.scss';
import LanguageSelector from '../languageSelector/LanguageSelector';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../../../redux/slices/languageSlice';

const Header: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let classname: string = 'header ';
  switch (location.pathname) {
    case '/': classname += 'home'; break;
    default: classname += 'other';
  }

  const [isOpen, setOpen] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateWindowWidth = () => {
      setTimeout(() => setWindowWidth(window.innerWidth), 400);
    };
    window.addEventListener('resize', updateWindowWidth);
    return () => window.removeEventListener('resize', updateWindowWidth);
  }, []);

  return (
    <>
      {windowWidth >= 767 ? (
        <header className={classname}>
          <div className="container">
            <Link to='/'><img src={logotype} alt="logotype" className="logotype" /></Link>
            <nav className="nav">
              <HashLink to='/#about' className="nav__link">{t("header.about")}</HashLink>
              <Link to='/test-drive' className="nav__link">{t("header.test_drive")}</Link>
              <Link to='/solutions' className="nav__link">{t("header.solutions")}</Link>
              <Link to='/products' className="nav__link">{t("header.products")}</Link>
              <Link to='/services' className="nav__link">{t("header.services")}</Link>
              <Link to='/partners' className="nav__link">{t("header.partners")}</Link>
              <HashLink to='/#footer' className="nav__link">{t("header.contacts")}</HashLink>

              <LanguageSelector />
            </nav>
          </div>
        </header>
      ) : (
        <>
          {isOpen ? (
            <>
              <svg className='burger__nav-close' onClick={() => setOpen(!isOpen)} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="2em" width="2em" xmlns="http://www.w3.org/2000/svg">
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
              </svg>
              <nav className="burger__nav">
                <Link to='/' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.main")}</Link>
                <HashLink to='/#about' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.about")}</HashLink>
                <Link to='/test-drive' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.test_drive")}</Link>
                <Link to='/solutions' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.solutions")}</Link>
                <Link to='/products' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.products")}</Link>
                <Link to='/services' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.services")}</Link>
                <Link to='/partners' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.partners")}</Link>
                <HashLink to='/#footer' className="burger__nav__link" onClick={() => setOpen(false)}>{t("header.contacts")}</HashLink>
                <a href="#" className="burger__nav__link" onClick={() => setOpen(false)}>support@right-systems.ru</a>
                <a href="#" className="burger__nav__link" onClick={() => setOpen(false)}>info@right-systems.ru</a>
                <a href="#" className="burger__nav__link" onClick={() => setOpen(false)}>+7(495) 532-30-75</a>
                <a href="#" className="burger__nav__link" onClick={() => dispatch(setLanguage('ru'))}>Русский</a>
                <a href="#" className="burger__nav__link" onClick={() => dispatch(setLanguage('en'))}>English</a>
              </nav>
            </>
          ) : (
            <svg onClick={() => setOpen(true)} className='burger__open' stroke="currentColor" fill="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="3em" width="3em" xmlns="http://www.w3.org/2000/svg">
              <line x1="21" y1="10" x2="3" y2="10"></line>
              <line x1="21" y1="6" x2="3" y2="6"></line>
              <line x1="21" y1="14" x2="3" y2="14"></line>
              <line x1="21" y1="18" x2="3" y2="18"></line>
            </svg>
          )}
        </>
      )}
    </>
  );
};

export default Header;
